import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";
import { getAuth, GoogleAuthProvider,signOut } from 'firebase/auth';
import { getMessaging } from "firebase/messaging"; // Import messaging

const firebaseConfig = {
  apiKey: "AIzaSyBicUv0aq0eT6ycjvb6KUeraWD_6DakEzo",
  authDomain: "student-mentor-dashboard.firebaseapp.com",
  projectId: "student-mentor-dashboard",
  storageBucket: "student-mentor-dashboard.firebasestorage.app",
  messagingSenderId: "597694001346",
  appId: "1:597694001346:web:3fed55f2f15e4e75ce8b5b",
  measurementId: "G-VTRY98KWRL"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const database = getDatabase(app);
const provider = new GoogleAuthProvider();
const storage = getStorage(app);
const messaging = getMessaging(app); 

export { database, storage, auth, provider, messaging,signOut }; 
